import { useMutation } from '@apollo/client';
import { CreCreate } from '@bakerweb/models';
import { toast } from 'react-toastify';
import { CREATE_CRE_MUTATION } from '../graphql/mutations/createCRE';

export function useCreateCre() {
  const [createCreMutation, { data, loading, error }] = useMutation(CREATE_CRE_MUTATION);

  const createCre = async (creCreateDto: CreCreate) => {
    try {
      const result = await createCreMutation({
        variables: { creCreateDto }
      });
      toast.success('Your inquiry is on the way!');
      return result;
    } catch (err) {
      toast.error(`There was an error sending your request. Please try again.`);
      return null;
    }
  };

  return { createCre, data, loading, error };
}
